import React, { useEffect, useRef } from 'react';

import { Box, Grid } from '@mui/material';

import EditBundleButton from './editBundleButton';

import Container from '@components/store/container';
import BundleHeaderBannerBreadcrumb from '@components/templates/bundleDetail/bundleBanner/header/breadCrumb';
import BundleHeaderBannerHighlightCover from '@components/templates/bundleDetail/bundleBanner/header/highlightCover';
import BundleHeaderBannerPurchaseDetail from '@components/templates/bundleDetail/bundleBanner/header/purchaseDetail';
import { GradientBackground } from '@components/templates/bundleDetail/bundleBanner/style';
import useBundleDetail from '@hooks/bundle/useBundleDetail';
import { BundleEntity } from '@redux/bundle/type/BundleDetailType';

type BundleHeaderBannerTypes = {
  bundleDetailSeo: BundleEntity;
  onHeaderSizeChange: (height: number) => void;
};
const BundleHeaderBanner = ({ bundleDetailSeo, onHeaderSizeChange }: BundleHeaderBannerTypes) => {
  const bundleHeaderBannerRef = useRef<HTMLElement>();
  const { name, idName } = bundleDetailSeo;

  useEffect(() => {
    if (!bundleHeaderBannerRef?.current?.offsetHeight) {
      return;
    }
    onHeaderSizeChange(bundleHeaderBannerRef?.current?.offsetHeight);
  }, [bundleHeaderBannerRef, onHeaderSizeChange]);

  const { bannerPrimaryColor, bannerSecondaryColor } = useBundleDetail();

  return (
    <GradientBackground
      primaryColor={bannerPrimaryColor}
      secondaryColor={bannerSecondaryColor}
      ref={bundleHeaderBannerRef}
    >
      <Box
        sx={{
          padding: {
            lg: '24px 0px 76px 0px',
            xs: '24px',
          },
        }}
      >
        <Container>
          <Grid container spacing={2} sx={{ mb: { md: '36px', xs: '24px' } }}>
            <Grid item md={9} xs={7}>
              <BundleHeaderBannerBreadcrumb bundleName={name} />
            </Grid>
            <Grid item md={3} xs={5} width="100%" display="flex" justifyContent="flex-end">
              <EditBundleButton bundleIdName={idName} />
            </Grid>
          </Grid>

          <Box px={{ md: 6, lg: 0 }} display="grid" gridTemplateColumns={{ lg: '487px 1fr' }} gap={{ xs: 3, lg: 10 }}>
            <BundleHeaderBannerHighlightCover bundleDetailSeo={bundleDetailSeo} />
            <BundleHeaderBannerPurchaseDetail bundleDetailSeo={bundleDetailSeo} />
          </Box>
        </Container>
      </Box>
    </GradientBackground>
  );
};

export default BundleHeaderBanner;
